import { render } from "./CodeBrackets.vue.js?vue&type=template&id=9fdc470e!=!../vue-loader/dist/index.js??ruleSet[0]!./CodeBrackets.vue?vue&type=template&id=9fdc470e"
import script from "./CodeBrackets.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./CodeBrackets.vue?vue&type=script&lang=js"
export * from "./CodeBrackets.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./CodeBrackets.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__